module.exports = __webpack_public_path__ + "img/discord.b5f6c068.svg";